module.exports = __webpack_public_path__ + "img/bbl.6f01a783.png";